module.exports = __webpack_public_path__ + "img/9788967354893.2290aea0.jpg";